import React, { useState } from "react";
import Footer from "./common/Footer";
import Introduction from "./common/Introduction";
import SequencesContainer from "./multipleChannels/SequencesContainer";
import FeedbacksContainer from "./common/FeedbacksContainer";

const MultipleChannelResults = ({ session, instances, results, feedbacks }) => {
  //Ce state est utilisé pour stocker le nom du participant sélectionné dans le menu déroulant de Introduction.js
  const [selectedName, setSelectedName] = useState(null);
  return (
    <div className="new-results">
      <Introduction
        session={session}
        playedTimes={instances.length}
        protocol={"Multiple channels"}
        onSelectName={setSelectedName}
        results={results}
      />
      <SequencesContainer
        session={session}
        instances={instances}
        results={results}
        selectedName={selectedName}
      />
      {feedbacks && feedbacks.length ? (
        <FeedbacksContainer feedbacks={feedbacks} selectedName={selectedName} />
      ) : (
        <></>
      )}
      <Footer />
    </div>
  );
};

export default MultipleChannelResults;
